module.exports = __webpack_public_path__ + "img/cpzxImg1.9771f5c8.png";